import sliceCreator from '../../index.jsx';
import {VERIFY_LOGIN_OTP} from '../../../constants/index.jsx';
const _verifyOtpAction = sliceCreator('VERIFY_LOGIN_OTP', VERIFY_LOGIN_OTP, 'post');

const { asyncAction: verifyOtpAction, reducer, clearData: clearVerifyOtpAction } = _verifyOtpAction;

export default reducer;

export {
    verifyOtpAction,
    clearVerifyOtpAction
}